var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ headerbg: (_vm.headerIndex == 0 || _vm.headerIndex == 3) && !_vm.iswrite }},[_c('button',{staticClass:"release",on:{"click":_vm.goRelease}},[_c('img',{attrs:{"src":(_vm.headerIndex == 0 || _vm.headerIndex == 3) && !_vm.iswrite
          ? '/static/images/community/new-img/release.png?v=1'
          : '/static/images/community/release.png?v=1'}})]),_vm._v(" "),_c('ul',_vm._l((_vm.nav),function(item,index){return _c('li',{class:{
        navColor: _vm.headerIndex == index,
        navColor0: (_vm.headerIndex == 0 || _vm.headerIndex == 3) && !_vm.iswrite
      },on:{"click":function($event){return _vm.headerClick(index)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7e6d2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/communityHeader.vue
// module id = null
// module chunks = 